import React, { useEffect, useContext } from "react";
import { store } from "../components/Store";
import { CancelRequestController } from "../util/cancel-request-controller"
import { CuraduriasAPI } from "../services/api/curadurias.";
import { LATAM_COUNTRIES } from "../curadurias/latam-countries";
import _ from "lodash";

let abortController = new CancelRequestController();

/**
 * Hook personalizado para obtener las listas de lectura de curadurias
 * Realiza una solicitud de obtención de informacion una vez y los guarda en el estado.
 * Devuelve los arreglos con las listas de lectura guardados desde el estado.
 *
 * @returns {{colecciones:array, series:array, paises:array, editoriales:array, loadCompleted:boolean, loading:boolean}} Objeto que contiene las listas, el estado de carga y el estado de completado.
 *   - colecciones: (Array) Lista de lectura
 *   - series: (Array) Lista de lectura
 *   - paises: (Array) Lista de lectura
 *   - editoriales: (Array) Lista de lectura
 *   - loadCompleted: (boolean) Indica si la carga  se ha completado.
 *   - loading: (boolean) Indica si las listas se están cargando actualmente.
 */
export const useCuradurias = () => {
    const globalState = useContext(store);
    const readingList = globalState?.state?.readingList?.list;
    const colecciones = globalState?.state?.readingList?.colecciones;
    const series = globalState?.state?.readingList?.series;
    const paises = globalState?.state?.readingList?.paises;
    const editoriales = globalState?.state?.readingList?.editoriales;
    const loading = globalState?.state?.readingList?.loading;
    const LoadCompleted = globalState?.state?.readingList?.loadCompleted;

    const sortedCountries = (countries) => {
        const lowerCaseLatam = LATAM_COUNTRIES.map(country => country.toLowerCase());
        const latamCountries = [];
        const otherCountries = [];
        countries.forEach(country => {
            if (lowerCaseLatam.includes(country?.nombre?.toLowerCase())) {
                latamCountries.push(country);
            } else {
                otherCountries.push(country);
            }
        });
        const sortedCountries = [
            ..._.sortBy(latamCountries, (country) => country?.nombre),
            ..._.sortBy(otherCountries, (country) => country?.nombre),
        ]

        return sortedCountries;
    }

    const fetchReadingList = async () => {
        globalState.dispatch({
            type: 'CHANGE',
            path: 'readingList.fetching',
            value: true
        })
        if (abortController?.signal?.aborted) {
            abortController = new CancelRequestController();
        }

        await CuraduriasAPI.getAll({ abortSignal: abortController.signal })
            .then(result => {
                globalState.dispatch({
                    type: 'CHANGE',
                    path: 'readingList',
                    value: {
                        ...globalState?.state?.readingList,
                        colecciones: result?.colecciones,
                        series: result?.series,
                        paises: sortedCountries(result?.paises),
                        editoriales: result?.editoriales,
                        loading: false,
                        loadCompleted: true,
                    }
                })
                //console.log('CURADURIAS fetched successfully:', result)
            })
            .catch(error => console.log(error))
            .finally(() => {
                globalState.dispatch({
                    type: 'CHANGE',
                    path: 'readingList.fetching',
                    value: false
                })
            })
    }

    useEffect(() => {
        if (!LoadCompleted) {
            fetchReadingList();
        }
        return () => {
            abortController.abort();
        }
    }, [readingList, LoadCompleted])


    return {
        colecciones: Array.isArray(colecciones) ? colecciones : [],
        series: Array.isArray(series) ? series : [],
        paises: Array.isArray(paises) ? paises : [],
        editoriales: Array.isArray(editoriales) ? editoriales : [],
        loading: loading,
        loadCompleted: LoadCompleted
    }
}